import { render, staticRenderFns } from "./LecturesRegionEntity.vue?vue&type=template&id=8413aef4&scoped=true"
import script from "./LecturesRegionEntity.vue?vue&type=script&lang=js"
export * from "./LecturesRegionEntity.vue?vue&type=script&lang=js"
import style0 from "./LecturesRegionEntity.vue?vue&type=style&index=0&id=8413aef4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8413aef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8413aef4')) {
      api.createRecord('8413aef4', component.options)
    } else {
      api.reload('8413aef4', component.options)
    }
    module.hot.accept("./LecturesRegionEntity.vue?vue&type=template&id=8413aef4&scoped=true", function () {
      api.rerender('8413aef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LecturesRegionEntity.vue"
export default component.exports